import React, { useState, useContext } from 'react'
import ASC_MONO_LOGO from '../assets/asc-monogram.jpg'
import DialogHelper from '../helper/DialogHelper'
import { useNavigate } from 'react-router-dom'
import { login } from '../services/AuthService'
import { UserContext } from '../helper/routes/UserContext'

export default function Login() {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [loading, setLoading] = useState(false)
    const [isOpen, setIsOpen] = useState(false)
    const [dialogMessage, setDialogMessage] = useState('')
    const navigate = useNavigate()
    const { setUserRole } = useContext(UserContext)
    const [showPassword, setShowPassword] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)

        const credentials = { username: email, password }
        const result = await login(credentials)

        if (result.error) {
            setDialogMessage(result.error)
            setIsOpen(true)
        } else {
            setUserRole(result.role)
            setTimeout(() => navigate('/'), 1000)
        }

        setLoading(false)
    }

    return (
        <div className="flex items-center justify-center min-h-screen w-full bg-neutral-50 p-4 sm:p-6">
            <div className="bg-white border border-gray-200 rounded-2xl flex flex-col md:flex-row w-full max-w-4xl overflow-hidden">
                {/* Left Panel */}
                <div className="w-full md:w-1/2 bg-red-600 text-white flex flex-col justify-center items-center p-8 sm:p-10 relative">
                    <div className="text-center">
                        <h2 className="text-xl sm:text-2xl font-semibold mb-2">Hello, welcome to!</h2>
                        <img src={ASC_MONO_LOGO} alt="ASC Logo" className="h-14 sm:h-16 mx-auto my-4" />
                        <h3 className="text-base sm:text-lg font-light tracking-wider">ASC ONLINE PORTAL</h3>
                    </div>
                    <div className="mt-6 md:mt-0 md:absolute md:bottom-4 md:left-0 w-full text-center text-xs opacity-80 flex flex-wrap justify-center gap-x-1">
                        <a
                            href="https://asconlineapp.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="!text-white underline hover:!text-red-100 transition mx-1"
                        >
                            Online Application
                        </a>
                        |
                        <a
                            href="https://asc.com.ph/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="!text-white underline hover:!text-red-100 transition mx-1"
                        >
                            Website
                        </a>
                        |
                        <a
                            href="https://www.facebook.com/ASCphilippines"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="!text-white underline hover:!text-red-100 transition mx-1"
                        >
                            Facebook
                        </a>
                    </div>
                </div>

                {/* Right Panel */}
                <div className="w-full md:w-1/2 bg-white p-8 sm:p-10">
                    <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">Sign In</h2>
                    <p className="text-gray-500 text-sm mb-8">Enter your details to sign in to your account</p>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            required
                            className="input-field py-3"
                        />

                        <div className="relative">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Enter your password"
                                required
                                className="input-field py-3 pr-12"
                            />
                            <span
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500 hover:text-gray-700"
                                title={showPassword ? 'Hide Password' : 'Show Password'}
                            >
                                {showPassword ? '🙈' : '👁️'}
                            </span>
                        </div>

                        <div className="flex justify-end text-sm">
                            <button type="button" className="text-red-600 hover:underline">
                                Forgot Password
                            </button>
                        </div>

                        <button type="submit" disabled={loading} className="btn-primary w-full py-3">
                            {loading ? 'Logging in...' : 'Log In'}
                        </button>
                    </form>
                </div>
            </div>

            {/* Dialog Box */}
            <DialogHelper
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                title="Login Failed"
                message={dialogMessage}
            />
        </div>
    )
}
